<div class="gitlab-issue-header op-tab-content--header">
  <svg op-gitlab-issue-open-icon size="small"></svg>
  <h3 class="title">
    {{text.title}}
  </h3>
</div>
